import styled from 'styled-components';
import { red, blue, teko } from '../../../utils/theme';

export const Text = styled.div`
  text-align: left;

  h3 {
    ${teko} font-size: 50px;
    font-weight: 500;
    letter-spacing: 3.99px;
    line-height: 40px;
    ${({ isBlack }) => (isBlack ? `color: ${blue}` : '')};
    ${({ center }) => (center ? 'text-align: center' : '')};
  }

  .accent {
    width: 24px;
    width: 1.5rem;
    margin: 16px 0;
    margin: 1rem 0 1.1rem 0;
    border-top: 4px solid ${red};

    &.center {
      margin: 1rem auto 1.1rem auto;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/title/styles/title.style.js